module.exports = __webpack_public_path__ + "img/823cda8.jpg";